/**
 * Late-synced email labels.
 *
 * An email whose store row was created days after it was sent (a catch-up
 * sync after a Gmail sync gap) must never read as a fresh customer email:
 * a July-30 PO recovered on Sep 25 was answered on Sep 28 as if new
 * (kanban 79a24ed2). The backend decides WHEN an email is late
 * (`late_sync_days` / `source_email_late_sync_days`); this module only
 * words the badge and its tooltip so the inbox and the Orders page agree.
 */
import { formatShortDate } from './dateFormatters';

function shortDate(dateStr: string | null | undefined): string {
  if (!dateStr) return 'unknown date';
  return formatShortDate(dateStr);
}

/** Badge text, e.g. "Received Jul 30 · synced Sep 25". */
export function formatLateSyncLabel(
  receivedAt: string | null | undefined,
  syncedAt: string | null | undefined,
): string {
  return `Received ${shortDate(receivedAt)} · synced ${shortDate(syncedAt)}`;
}

/** Tooltip: what happened and what the reader should do about it. */
export function lateSyncTitle(
  gapDays: number,
  receivedAt: string | null | undefined,
  syncedAt: string | null | undefined,
): string {
  const days = gapDays === 1 ? '1 day' : `${gapDays} days`;
  return (
    `This email was sent ${shortDate(receivedAt)} but only reached the portal ` +
    `${shortDate(syncedAt)} (${days} later) because of a mail sync gap. ` +
    'The customer did not just send it. Check with them before acting on it as new.'
  );
}
